import React, { Component } from 'react'

interface MultiLineDTProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const ComponentIconDT: React.FC<MultiLineDTProps> = ({
  size = 20,
  color = '#003366',
  className,
  onClick,
}) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.3333 6.89102V3.52435C18.3333 2.19935 17.8 1.66602 16.475 1.66602H13.1083C11.7833 1.66602 11.25 2.19935 11.25 3.52435V6.89102C11.25 8.21602 11.7833 8.74935 13.1083 8.74935H16.475C17.8 8.74935 18.3333 8.21602 18.3333 6.89102Z" stroke={color} stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8.74935 7.09935V3.31602C8.74935 2.14102 8.21602 1.66602 6.89102 1.66602H3.52435C2.19935 1.66602 1.66602 2.14102 1.66602 3.31602V7.09102C1.66602 8.27435 2.19935 8.74102 3.52435 8.74102H6.89102C8.21602 8.74935 8.74935 8.27435 8.74935 7.09935Z" stroke={color} stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8.74935 16.475V13.1083C8.74935 11.7833 8.21602 11.25 6.89102 11.25H3.52435C2.19935 11.25 1.66602 11.7833 1.66602 13.1083V16.475C1.66602 17.8 2.19935 18.3333 3.52435 18.3333H6.89102C8.21602 18.3333 8.74935 17.8 8.74935 16.475Z" stroke={color} stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M12.084 14.584H17.084" stroke={color} stroke-width="1.3" stroke-linecap="round" />
    <path d="M14.584 17.084V12.084" stroke={color} stroke-width="1.3" stroke-linecap="round" />
  </svg>

)

export default ComponentIconDT;
